import React from "react";
import { Link } from "react-router-dom";
import LogoLight from "../assets/images/property/pmgluxury/pmg_lux_logo_light.png";
import { MdKeyboardArrowRight } from "react-icons/md";

export default function Footer() {
  return (
    <footer className="relative bg-slate-900 dark:bg-slate-950 mt-24">
      {/* Top gold hairline */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-gold-500/60 to-transparent"></div>

      <div className="container">
        <div className="relative py-20">
          <div className="grid md:grid-cols-12 grid-cols-1 gap-12 md:gap-16">
            <div className="lg:col-span-5 md:col-span-12 text-center md:text-start">
              <Link to="/" className="inline-block focus:outline-none">
                <img
                  src={LogoLight}
                  alt="PMG Luxury Rentals"
                  className="h-24 md:h-36 w-auto object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </Link>
              <p className="font-display italic text-gold-300 mt-6 text-lg tracking-wide">
                Premium Luxury Home & Liveaboard Boat Slip Rentals
              </p>
              <div className="flex items-center justify-center md:justify-start gap-3 mt-5">
                <span className="h-px w-10 bg-gold-500/60"></span>
                <span className="text-gold-400 text-xs tracking-[0.3em] uppercase">Florida</span>
                <span className="h-px w-10 bg-gold-500/60"></span>
              </div>
            </div>

            <div className="lg:col-span-3 md:col-span-6">
              <p className="font-display italic text-gold-400 tracking-[0.25em] uppercase text-xs mb-5">
                — Explore —
              </p>
              <ul className="list-none space-y-3">
                <li>
                  <Link
                    to="/list"
                    className="text-gray-300 hover:text-gold-300 duration-500 ease-in-out flex items-center text-sm tracking-wide"
                  >
                    <MdKeyboardArrowRight className="me-1 text-xl text-gold-500/70" />
                    Properties
                  </Link>
                </li>
                <li>
                  <Link
                    to="/aboutus"
                    className="text-gray-300 hover:text-gold-300 duration-500 ease-in-out flex items-center text-sm tracking-wide"
                  >
                    <MdKeyboardArrowRight className="me-1 text-xl text-gold-500/70" />
                    About PMG
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="text-gray-300 hover:text-gold-300 duration-500 ease-in-out flex items-center text-sm tracking-wide"
                  >
                    <MdKeyboardArrowRight className="me-1 text-xl text-gold-500/70" />
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            <div className="lg:col-span-4 md:col-span-6">
              <p className="font-display italic text-gold-400 tracking-[0.25em] uppercase text-xs mb-5">
                — Legal —
              </p>
              <ul className="list-none space-y-3">
                <li>
                  <Link
                    to="/terms"
                    className="text-gray-300 hover:text-gold-300 duration-500 ease-in-out flex items-center text-sm tracking-wide"
                  >
                    <MdKeyboardArrowRight className="me-1 text-xl text-gold-500/70" />
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-gray-300 hover:text-gold-300 duration-500 ease-in-out flex items-center text-sm tracking-wide"
                  >
                    <MdKeyboardArrowRight className="me-1 text-xl text-gold-500/70" />
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="py-8 border-t border-gold-500/20">
        <div className="container">
          <div className="text-center font-display italic text-slate-300 leading-relaxed">
            <p className="text-gold-200">PMG Luxury Rentals, L.L.C.</p>
            <p className="text-sm text-slate-400 not-italic font-sans mt-2 tracking-wide">
              82801 Overseas Highway, Unit 1225, Islamorada, FL 33036
            </p>
            <p className="text-xs text-slate-500 not-italic font-sans mt-3 tracking-[0.2em] uppercase">
              © {new Date().getFullYear()} PMG Luxury Rentals, L.L.C. — All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
